export const commentsTableColumns = [
  { field: 'dateTime', headerName: 'Date & Time', width: 100 },
  { field: 'user', headerName: 'From', width: 100, isRowHeader: true },
  { field: 'comment', headerName: 'Comment', width: 250 },
]
